import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { findAllImage, findEntityData, findImage } from "../../api/apiService";
import arrow from "../../assets/arrow.webp";

const OurService = () => {
    const contentRefs = useRef([]);
    const [activeIndex, setActiveIndex] = useState(0);
    const [section1, setSection1] = useState()
    const [imageUrls, setImageUrls] = useState([]);
    const [scales, setScales] = useState(Array(section1?.data?.length).fill(0));
    const findData = async () => {
        const res = await findEntityData('sss_home_our_services')
        const renderAllImage = async (id) => {
            if (!id) return [];
            const idArray = Array.isArray(id) ? id : [id];
            const idsParam = idArray.join(",");
            const res = await findAllImage(idsParam);
            return res?.data?.[0]?.data || [];
        };
        // Wait for all images to resolve
        let imgArr = res?.data?.[0]?.data?.map(item => (item.img))
        setImageUrls((await renderAllImage(imgArr)));
        setSection1(res?.data?.[0])
    }

    useEffect(() => {
        findData();
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            const threshold = window.innerHeight;
            const newScales = contentRefs.current?.map((el) => {
                if (!el) return 0;
                const rect = el.getBoundingClientRect();
                const top = rect.top;

                if (top >= threshold || top + rect.height <= 0) return 0;

                const progress = 1 - Math.min(Math.max(top / threshold, 0), 1);
                return 0.5 + progress * 0.5;
            });
            while (newScales.length < section1?.data.length) newScales.push(0);

            setScales(newScales);
            let bestIndex = 0;
            let bestVal = newScales[0] || 0;
            newScales.forEach((v, i) => {
                if (v > bestVal) {
                    bestVal = v;
                    bestIndex = i;
                }
            });
            setActiveIndex(bestIndex);
        };

        window.addEventListener("scroll", handleScroll, { passive: true });
        window.addEventListener("resize", handleScroll);
        handleScroll();
        return () => {
            window.removeEventListener("scroll", handleScroll);
            window.removeEventListener("resize", handleScroll);
        };
    }, [section1?.data]);

    useEffect(() => {
        contentRefs.current = contentRefs.current.slice(0, section1?.data.length);
        setScales(section1?.data?.map(() => 0));
        setActiveIndex(0);
    }, [section1?.data]);
    return (
        <div>
            <section className="our-service py-16 px-6 sm:px-8 lg:px-24">
                <div className=" text-center !mb-10 md:!-mb-[70px]">
                    <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#F37934]">
                        {section1?.heading}
                    </h2>
                </div>
                <section className="relative hidden md:flex max-w-7xl mx-auto">
                    <div className="w-1/2 pr-8">
                        <div className="sticky top-0 h-screen flex items-center relative overflow-hidden">
                            {section1?.data?.map((item, index) => {
                                const isActive = index === activeIndex;
                                return (
                                    <div
                                        key={index}
                                        className="absolute inset-0 flex flex-col items-start justify-center transition-transform duration-300 ease-in"
                                        style={{
                                            opacity: isActive ? 1 : 0,
                                            transform: isActive ? "translateX(0)" : "translateX(-60%)",
                                            pointerEvents: isActive ? "auto" : "none",
                                        }}
                                    >
                                        <h2 className="text-4xl font-bold mb-4">{item.title}</h2>
                                        <p className="text-lg leading-8">{item.description}</p>
                                        <Link
                                            to={'/services' + item.path}
                                            className="flex items-center gap-2 mt-4 font-semibold hover:underline"
                                        >
                                            <img src={arrow} alt="arrow" className="w-12 h-12" />
                                        </Link>
                                    </div>
                                );
                            })}
                        </div>
                        {section1?.data?.map((_, i) => (
                            <div
                                key={`sentinel-${i}`}
                                ref={(el) => (contentRefs.current[i] = el)}
                                className="h-screen"
                                aria-hidden="true"
                                style={{ visibility: "hidden" }}
                            />
                        ))}
                    </div>
                    <div className="w-1/2 h-screen sticky top-0 flex items-center justify-center">
                        <div className="relative w-full h-[80%] flex items-center justify-center perspective">
                            {section1?.data?.map((item, index) => {
                                const isActive = index === activeIndex;
                                return (
                                    <img
                                        key={index}
                                        src={imageUrls[index]}
                                        alt={`service-${index}`}
                                        className={`
          absolute object-contain transition-transform duration-700 ease-in-out
          ${isActive ? "rotate-y-0 opacity-100" : "rotate-y-180 opacity-0"}
        `}
                                        style={{
                                            width: "75%",
                                            height: "auto",
                                            backfaceVisibility: "hidden",
                                            zIndex: isActive ? 10 : 0,
                                        }}
                                    />
                                );
                            })}
                        </div>
                    </div>
                </section>
                <section className="flex flex-col md:hidden max-w-3xl mx-auto px-4">
                    <div className="pb-20">
                        {section1?.data?.map((item, index) => (
                            <div key={index} className="flex flex-col items-center mt-8 text-center">
                                <h3 className="text-xl font-semibold text-[#F37934] mb-2">
                                    {item.title}
                                </h3>
                                <div className="relative h-[20rem] w-full my-4">
                                    <img
                                        src={imageUrls[index]}
                                        alt={`mobile-${index}`}
                                        className="w-full h-full object-contain rounded-lg"
                                    />
                                </div>
                                <p className="text-[#56453F] text-base leading-relaxed px-2">
                                    {item.description}
                                </p>
                            </div>
                        ))}
                    </div>
                </section>
            </section>
        </div>
    )
}

export default OurService
